import { Link } from "react-router-dom";
import { Typography, Card, CardContent, CardMedia, Box } from "@mui/material";
import { ROUTES } from "@/utils/navigation";
import { imageContainerStyles, imageStyles } from "../../styles";
import useResponsive from "@/hooks/useResponsive";

interface IProps {
  product: IProduct;
  closeDropDown: () => void;
}

const ProductCard: React.FC<IProps> = ({ product, closeDropDown }) => {
  const { id, name, image } = product;
  const isMobile = useResponsive("down", "lg");

  return (
    <Card
      component={Link}
      to={`${ROUTES.trackingDevices}/${id}`}
      onClick={closeDropDown}
      variant="outlined"
      sx={{
        border: "none",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        textDecoration: "none",
      }}
    >
      {/* Image */}
      <Box sx={imageContainerStyles}>
        <CardMedia component="img" image={image} alt={name} sx={imageStyles} />
      </Box>

      {/* Description */}
      <CardContent sx={{ padding: "0 !important" }}>
        <Box
          display="flex"
          flexDirection={isMobile ? "row" : "column"}
          mb={{ xs: 1, lg: 2 }}
          justifyContent="space-between"
        >
          <Typography
            variant="h6"
            component="h3"
            color="text.primary"
            mb={{ xs: 0, lg: 0.5 }}
          >
            {name}
          </Typography>
          {/* <Typography
            variant="body1"
            fontWeight={700}
            fontSize={16}
            color="text.primary"
            component="p"
          >
            ${price}
          </Typography> */}
        </Box>
        <Typography
          variant="subtitle1"
          component="span"
          color="text.accent"
          fontWeight={700}
        >
          Learn more
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ProductCard;
